import styled from 'styled-components';

export const DocumentContainer = styled.div`
  background-color: ${props => props.status === 'archived' ? props.theme.colors.secondary : props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.silverGrayFour};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 180px;
  display: flex;
  flex-direction: column;
  font-family: 'Inter';
  min-width: 0;
  width: 100%;
  container-type: inline-size;
  container-name: document-container;

  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const DocumentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 16px;
  font-family: 'Inter';
  min-height: 24px;
`;

export const DocumentHeaderLeft = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  word-break: break-word;
  flex: 1;
  padding-right: 8px;
  font-family: 'Inter';
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const DocumentHeaderRight = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  font-family: 'Inter';
`;

export const ArchivedStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: ${props => props.theme.colors.warningLight};
  color: ${props => props.theme.colors.warning};
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  font-family: 'Inter';
`;

export const DocumentContent = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
  flex: 1;
  font-family: 'Inter';
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const DocumentFooter = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
  font-family: 'Inter';
  width: 100%;
  min-height: 20px;

  div {
    display: flex;
    align-items: center;
  }

  @container (max-width: 260px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const Title = styled.span`
  font-weight: 600;
  color: ${(props) => props.theme.colors.darkGray};
  margin-right: 4px;
  font-family: 'Inter';
`;

export const Value = styled.span`
  color: #666;
  font-family: 'Inter';
`; 